import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";

@Component({
  selector: 'vex-workout-history',
  templateUrl: './workout-history.component.html',
  styleUrls: ['./workout-history.component.scss']
})
export class WorkoutHistoryComponent implements OnInit {
  workoutNameLoader: boolean = true;
  mapNames = {};
  environment = environment.baseURL;
  workoutsPlaceholder = Array(5);

  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged) {
      if (this.guiService.userLogged.workoutInfo.lastWorkoutHistory) {
        const ids = [];
        this.guiService.userLogged.workoutInfo.lastWorkoutHistory.forEach(element => {
          ids.push(element.workoutId)
        });
        this.getWorkoutNames(ids);
      }
    }else{
      this.guiService.goTo('main/home');
    }

  }

  getProgramName(programId) {
    return this.guiService.programs.find(x => x.id === programId).i18nName || null;
  }

  getWorkoutNames(ids) {
    const param = {
      userId: this.guiService.userLogged.user.id,
      workoutIds: ids
    }
    this.workoutNameLoader = true;
    this.restService.postService('node', '/workout-names', param).subscribe((ris) => {
      ris.forEach(element => {
        this.mapNames[element._id] = element['i18nName'];
      });
      this.workoutNameLoader = false;
      setTimeout(() => {
        localStorage.getItem('tourWorkoutHistoryShowed') ? null : this.startTour();
      }, 1000);
    })
  }

  startTour(): void {
    localStorage.setItem('tourWorkoutHistoryShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.workout-history-title', popover: { title: this.translate.instant('TUTORIALS.workout-history.completedWorkoutsListTitle'), description: this.translate.instant('TUTORIALS.workout-history.completedWorkoutsListDescription'), side: 'bottom' } },
        { element: '.last-workout-tutorial', popover: { title: this.translate.instant('TUTORIALS.workout-history.sessionDetailsTitle'), description: this.translate.instant('TUTORIALS.workout-history.sessionDetailsDescription'), side: 'bottom' } },
      ]
    });

    driverObj.drive();
  }

}

